import { render, staticRenderFns } from "./UseVoucherPromotion.vue?vue&type=template&id=2706e1b5&scoped=true&"
import script from "./UseVoucherPromotion.vue?vue&type=script&lang=js&"
export * from "./UseVoucherPromotion.vue?vue&type=script&lang=js&"
import style0 from "./UseVoucherPromotion.vue?vue&type=style&index=0&id=2706e1b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706e1b5",
  null
  
)

export default component.exports